<template>
  <div class="individual-goodnews-poster">
    <el-dialog
      title="喜报制作"
      :visible.sync="formPoster"
      width="30%"
      @close="formPosterClose"
    >
      <el-form
        :model="uploadPosterForm"
        label-width="100px"
        :rules="uploadPosterFormRules"
        ref="uploadPosterFormRef"
      >
        <el-form-item label="赛区:" prop="districtName">
          <el-select
            placeholder="请选择"
            style="width: 80%"
            v-model="uploadPosterForm.districtName"
            clearable
          >
            <el-option
              v-for="item in dict_district"
              :key="item.id"
              :label="item.districtName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校名:" prop="schoolName">
          <el-input
            v-model="uploadPosterForm.schoolName"
            autocomplete="off"
            placeholder="请输入"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校英文名:" prop="enSchoolName">
          <el-input
            v-model="uploadPosterForm.enSchoolName"
            autocomplete="off"
            placeholder="请输入"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否分年级制作："
          prop="gradesGroup"
          label-width="140px"
        >
          <el-radio-group v-model="uploadPosterForm.gradesGroup">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="列数:" prop="columnNum">
          <el-select
            v-model="uploadPosterForm.columnNum"
            placeholder="请选择"
            style="width: 80%"
          >
            <el-option label="1" value="1"></el-option>
            <el-option label="2" value="2"></el-option>
            <el-option label="3" value="3"></el-option>
            <el-option label="4" value="4"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-upload
          class="upload-demo"
          ref="uploadPosterRef"
          :action="uploadPosterForm.uploadUrl"
          :data="{
            schoolName: uploadPosterForm.schoolName,
            columnNum: uploadPosterForm.columnNum,
            gradesGroup:
              uploadPosterForm.gradesGroup === '是' ? 'true' : 'false',
            districtName: uploadPosterForm.districtName,
          }"
          :before-upload="beforeUpload"
          :on-preview="uploadPosterProgress"
          :on-success="uploadPosterSuccess"
          :on-error="uploadPostereError"
          :on-exceed="uploadPosterExceed"
          :headers="uploadPosterForm.headerObj"
          :limit="1"
          :auto-upload="true"
        >
          <el-button
            style="margin-left: 10px"
            type="primary"
            size="small"
            @click="downLoadUploadPoster"
            >下载模版</el-button
          >
          <el-button size="small" type="primary" slot="trigger"
            >上传文件</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="success"
            size="small"
            :icon="goodNewsLoading ? 'el-icon-loading' : ''"
            @click="generateGoodnewsClicked"
            >生成喜报</el-button
          >
        </el-upload>
      </span>
    </el-dialog>
    <div id="printId" class="html2canvasDivShow print-canvas-root" ref="html2canvasRef">
      <div class="pic">
        <img src="@/assets/img/CEBSB_goodnews_bg_up_2025_2026_en.png" />
      </div>
      <div class="nameList">
        <div class="area_name">
          <div>{{ lessongoodNewsDistrictName }}</div>
        </div>
        <div class="class_name">
          {{ lessongoodNewsSchoolName }}
        </div>
        <div class="en_class_name">
          <div>{{ uploadPosterForm.enSchoolName }}</div>
        </div>
        <div class="multicolumn">
          <div
            v-bind:style="player_nameclass"
            v-for="(itemList, index) in finalDataList"
            :key="index"
          >
            <div
              class="multicolumn-item"
              v-for="(item, itemIndex) in itemList"
              :key="itemIndex"
            >
              <div v-if="item.gradeName" class="gradeName_class">
                {{ item.gradeName }}
              </div>
              <div v-else class="userName_class">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pic2">
        <img src="@/assets/img/CEBSB_goodnews_bg_down1_2024_2025_en.png" />
      </div>
      <div class="pic4">
        <img src="@/assets/img/CEBSB_goodnews_text_en.png" alt="" />
      </div>
    </div>
    <div
      v-for="(item, index) in batchFinalDataList"
      :key="index"
      :id="`batchprintImage_${index}`"
      class="html2canvasDivShow batch-print-canvas"
      :ref="'html2canvasRef_' + index"
    >
      <div class="pic">
        <img src="@/assets/img/CEBSB_goodnews_bg_up_2025_2026_en.png" />
      </div>
      <div class="nameList">
        <div class="area_name">
          <div>{{ lessongoodNewsDistrictName }}</div>
        </div>
        <div class="class_name">
          <div>{{ lessongoodNewsSchoolName }}</div>
        </div>
        <div class="en_class_name">
          <div>{{ uploadPosterForm.enSchoolName }}</div>
        </div>
        <div class="firstPage">{{ item.gradeName }}</div>
        <div class="multicolumn1">
          <div
            class="player-name"
            v-bind:style="player_nameclass"
            v-for="(userItem, childIndex) in item.userName"
            :key="childIndex"
          >
            {{ userItem }}
          </div>
        </div>
      </div>
      <div class="pic2">
        <img src="@/assets/img/CEBSB_goodnews_bg_down1_2024_2025_en.png" />
      </div>
      <div class="pic4">
        <img src="@/assets/img/CEBSB_goodnews_text_en.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { queryDistrictPage, downLoad } from '@/http/api'
import env from '@/http/env'

export default {
  name: 'IndividualGoodnewsPoster',
  data () {
    return {
      goodNewsData: null,
      lessongoodNewsSchoolName: '',
      lessongoodNewsDistrictName: '',
      finalDataList: [],
      batchFinalDataList: [],
      lessonArr: {
        oneGradeNames: '一年级',
        twoGradeNames: '二年级',
        threeGradeNames: '三年级',
        fourGradeNames: '四年级',
        fiveGradeNames: '五年级',
        sixGradeNames: '六年级',
        sevenGradeNames: '七年级',
        eightGradeNames: '八年级',
        nineGradeNames: '九年级'
      },
      player_nameclass: {
        width: '100%',
        color: '#e8c77a'
      },
      dict_district: [],
      formPoster: false,
      uploadPosterForm: {
        uploadUrl: env.baseIP + 'goodNews/importExcel',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        },
        schoolName: '',
        enSchoolName: '',
        columnNum: '',
        gradesGroup: '',
        districtName: ''
      },
      uploadPosterFormRules: {
        districtName: [{ required: true, message: '请选择赛区', trigger: 'change' }],
        schoolName: [{ required: true, message: '请输入学校名', trigger: 'blur' }],
        columnNum: [{ required: true, message: '请选择列数', trigger: 'change' }],
        gradesGroup: [{ required: true, message: '请选择是否分年级', trigger: 'change' }]
      },
      goodNewsLoading: false,
      loadingMsg: null
    }
  },
  watch: {
    'uploadPosterForm.gradesGroup' () {
      this.$nextTick(() => {
        this.dataProcessing()
      })
    },
    'uploadPosterForm.columnNum' () {
      this.$nextTick(() => {
        this.dataProcessing()
      })
    },
    'uploadPosterForm.districtName' () {
      this.$nextTick(() => {
        this.dataProcessing()
      })
    },
    'uploadPosterForm.schoolName' () {
      this.$nextTick(() => {
        this.dataProcessing()
      })
    },
    'uploadPosterForm.enSchoolName' () {
      this.$nextTick(() => {
        this.dataProcessing()
      })
    }
  },
  methods: {
    open () {
      this.getDistrictList()
      this.formPoster = true
      this.$nextTick(() => {
        if (this.$refs.uploadPosterRef) {
          this.$refs.uploadPosterRef.clearFiles()
        }
      })
    },
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    formPosterClose () {
      this.goodNewsData = null
      this.finalDataList = []
      this.batchFinalDataList = []
      this.$refs.uploadPosterFormRef.resetFields()
      this.$nextTick(() => {
        if (this.$refs.uploadPosterRef) {
          this.$refs.uploadPosterRef.clearFiles()
        }
      })
    },
    async downLoadUploadPoster () {
      downLoad().then((res) => {
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        var url = res.data
        var link = document.createElement('a')
        try {
          link.href = url
        } catch (error) {
          link.href = window.URL.createObjectURL(url)
        }
        link.click()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    beforeUpload () {
      this.$refs.uploadPosterFormRef.validate(async valid => {
        if (!valid) {
          this.$refs.uploadPosterRef.clearFiles()
          return false
        } else {
          return true
        }
      })
    },
    uploadPosterProgress () {
      this.$common.openLoading()
    },
    uploadPosterSuccess (res) {
      if (res.code === 200) {
        this.goodNewsData = res.data
        this.dataProcessing()
      } else {
        this.$refs.uploadPosterRef.clearFiles()
        return this.$message.warning('文件解析失败，请重新上传！')
      }
    },
    dataProcessing () {
      if (this.goodNewsData == null) return
      const { districtName, columnNum } = this.uploadPosterForm
      if (districtName === '' || districtName == null || columnNum === '' || columnNum == null) return
      const districtRow = this.dict_district.find(item => item.id === districtName)
      if (!districtRow) return
      this.lessongoodNewsSchoolName = this.uploadPosterForm.schoolName
      this.lessongoodNewsDistrictName = districtRow.districtName.replace('赛', '选')
      if (this.lessongoodNewsDistrictName === '全国非城市选区一部' || this.lessongoodNewsDistrictName === '全国非城市选区二部') {
        this.lessongoodNewsDistrictName = '全国选区'
      }
      this.$data.player_nameclass.width = (100 / Number(columnNum)) + '%'
      if (this.uploadPosterForm.gradesGroup === '否') {
        var obj = this.goodNewsData.goodNewsDetails
        const finalList = []
        for (const v in obj) {
          finalList.push({ gradeName: this.lessonArr[v] })
          finalList.push.apply(finalList, obj[v])
        }
        const twoDimensionalArray = []
        var rowsNumber = parseInt(finalList.length / Number(columnNum))
        for (let index = 0; index < Number(columnNum); index++) {
          if (finalList.length % Number(columnNum) !== 0) {
            if (index < (finalList.length % Number(columnNum))) {
              twoDimensionalArray.push(finalList.slice(index * (rowsNumber + 1), (rowsNumber + 1) * (index + 1)))
            } else {
              twoDimensionalArray.push(finalList.slice(index * (rowsNumber + 1), (index + 1) + ((index + 1) * rowsNumber)))
            }
          } else {
            twoDimensionalArray.push(finalList.slice(index * rowsNumber, (index + 1) * rowsNumber))
          }
        }
        this.finalDataList = twoDimensionalArray
      }
    },
    generateGoodnewsClicked () {
      this.openLoading()
      this.$refs.uploadPosterFormRef.validate(async valid => {
        if (!valid) {
          this.closeLoading()
          return
        }
        if (this.$refs.uploadPosterRef.uploadFiles.length === 0) {
          this.closeLoading()
          return this.$message.warning('请选择要上传的文件')
        }
        if (!this.goodNewsData || !this.goodNewsData.goodNewsDetails) {
          this.closeLoading()
          return this.$message.warning('请先成功上传并解析 Excel')
        }
        var obj = this.goodNewsData.goodNewsDetails
        const finalList = [{ gradeName: '', userName: [] }]
        if (this.uploadPosterForm.gradesGroup === '是') {
          for (const v in obj) {
            if (obj[v].length >= Number(this.uploadPosterForm.columnNum)) {
              finalList.push({ gradeName: this.lessonArr[v], userName: obj[v] })
            } else {
              this.$curUtils.closeLoading(this)
              this.closeLoading()
              return this.$message({
                message: '列数不能大于单年级人数',
                type: 'warning'
              })
            }
          }
          this.batchFinalDataList = finalList
          for (let index = 0; index < finalList.length; index++) {
            await this.batchprintImage('batchprintImage_' + index, index)
          }
          this.closeLoading()
        } else {
          this.printImage()
        }
      })
    },
    printImage () {
      const el = this.$refs.html2canvasRef
      if (!el) {
        this.closeLoading()
        return
      }
      html2canvas(el, {
        height: el.offsetHeight - 150,
        scale: 4,
        dpi: 900
      }).then(canvas => {
        const printUrl = canvas.toDataURL('image/png', 1)
        const eleLink = document.createElement('a')
        eleLink.href = printUrl
        eleLink.download = 'pictureName'
        document.body.appendChild(eleLink)
        eleLink.click()
        document.body.removeChild(eleLink)
        this.$curUtils.closeLoading(this)
        this.closeLoading()
      })
    },
    async batchprintImage (batchprintId, refIndex) {
      if (batchprintId === 'batchprintImage_0') return
      await this.$nextTick()
      const itemRef = this.$refs['html2canvasRef_' + refIndex]
      const box = document.getElementById(batchprintId)
      if (!box || !itemRef || !itemRef[0]) return
      const canvas = await html2canvas(box, {
        height: itemRef[0].offsetHeight - 150,
        scale: 4,
        dpi: 900
      })
      const printUrl = canvas.toDataURL('image/png', 1)
      const eleLink = document.createElement('a')
      eleLink.href = printUrl
      eleLink.download = 'pictureName'
      document.body.appendChild(eleLink)
      eleLink.click()
      document.body.removeChild(eleLink)
    },
    openLoading () {
      this.goodNewsLoading = true
      this.loadingMsg = this.$message({
        message: '喜报生成中，请耐心等待...',
        type: 'warning',
        duration: 0
      })
    },
    closeLoading () {
      this.goodNewsLoading = false
      if (this.loadingMsg) {
        this.loadingMsg.close()
        this.loadingMsg = null
      }
    },
    uploadPostereError (error) {
      this.$common.closeLoading()
      console.log('uploadPostereError', error)
      this.$message.error(error)
    },
    uploadPosterExceed (files, fileList) {
      this.$set(fileList[0], 'raw', files[0])
      this.$set(fileList[0], 'name', files[0].name)
    }
  }
}
</script>

<style lang="less" scoped>
.individual-goodnews-poster {
  .html2canvasDivShow {
    position: relative;
    z-index: -1;
  }

  .player-name {
    margin-bottom: 5px;
    font-size: 18px;
    font-family: "xique";
  }

  .gradeName_class {
    color: white;
    font-size: 18px;
    font-family: "xique";
  }

  .userName_class {
    font-size: 16px;
    font-family: "xique";
  }

  .multicolumn1 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 60%;
    margin-left: 15%;
    height: 93%;
  }

  .multicolumn-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    line-height: 30px;
  }

  .multicolumn {
    display: flex;
    flex-direction: row;
    width: 60%;
    margin-left: 15%;
    justify-content: center;
    height: 93%;
  }

  .firstPage {
    width: 50%;
    margin-left: 15%;
    color: #fff;
    font-size: 20px;
    font-family: "xique";
    margin-bottom: 20px;
  }

  .nameList {
    width: 100%;
    min-height: 279px;
    position: relative;
    margin-top: -150px;
    text-align: center;
    color: #e8c77a;
    background: url(../../../../../assets/img/CEBSB_goodnews_bg_middle3.png);
    background-size: 100% auto;
    z-index: 100;
  }

  img {
    width: 100%;
  }

  .class_name {
    text-align: center;
    font-family: "xique";
    width: 50%;
    margin-left: 16.5%;
    color: #ffffff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .en_class_name {
    text-align: center;
    font-family: "xique";
    width: 60%;
    margin-left: 11%;
    margin-bottom: 10px;
    color: #ffffff;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .area_name {
    text-align: center;
    font-family: "xique";
    width: 50%;
    margin-left: 16.5%;
    margin-bottom: 10px;
    color: #f7b52c;
    font-size: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .class_name img {
    height: 100%;
    width: 15%;
  }

  .class_name div {
    position: relative;
  }

  .pic {
    position: relative;
    width: 100%;
    top: 0;
  }

  .pic4 {
    position: absolute;
    right: 20px;
    top: 156px;
    width: 110px;
    z-index: 101;
  }

  .pic4 img {
    width: 100%;
    height: auto;
  }

  .pic2 {
    width: 100%;
    position: relative;
    top: -170px;
    z-index: 99;
    background-color: #3f0000;
  }

  .pic2 img {
    width: 100%;
  }

  .print-canvas-root,
  .batch-print-canvas {
    position: relative;
    width: 560px;
    min-height: 760px;
    letter-spacing: 1px;
    background-color: #3f0000;
  }

  #printId {
    position: fixed;
  }
}
</style>
